import { z } from "zod";
export const S3Config = z.object({
    accessKeyId: z.string().nonempty("Access Key ID is required"),
    secretAccessKey: z.string().nonempty("Secret Access Key is required"),
    region: z.string().nonempty("Region is required"),
    location: z.string().nonempty("Bucket Location is required"),
    endpoint: z.string().nonempty("Endpoint is required"),
});
//# sourceMappingURL=organization.s3-config.js.map